import React, { useEffect } from 'react';
import { SendInvite } from "../../REST/alert";
import { useForm, Controller } from "react-hook-form";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DateTimePicker';
import { useNavigate } from 'react-router-dom';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';

export default function FormDialog() {
    const navigate = useNavigate()

    const schema = yup.object({
        summary: yup.string().trim().required(),
        description: yup.string().trim().required(),
        location: yup.string().trim().required(),
        start: yup.date().required(),
        end: yup.date().required(),
        emails: yup.string().trim().required()
    }).required();

    const { control, handleSubmit, formState: { errors }, clearErrors, reset } = useForm({
        defaultValues: {
            summary: '',
            description: '',
            location: '',
            start: null,
            end: null,
            emails: ''

        },
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        clearErrors()
        reset()
    }, [clearErrors, reset])

    const onSubmit = (data) => {
        const calendar = {
            start: data.start,
            end: data.end,
            summary: data.summary,
            description: data.description,
            location: data.location,
            url: 'https://leasing.revjet360.com',
            organizer: {
                name: 'RevJet Administrator',
                email: 'admin@delasoftsupport.com'
            },
        }

        const invite = { emails: data.emails.split(','), calendar, title: data.summary, content: data.description, name: 'Meeting Invite' }
        SendInvite(invite)
        reset()
    }

    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'


    return (
        <PageShell>
            <PageHeader title="Appointments" back onBack={() => navigate(-1)} />

            <PageContent sx={{ p: { xs: 2, md: 3 } }}>
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: 840,
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={2}>
                            <Controller name="summary" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.summary)} helperText={errors.summary && errors.summary.message} fullWidth label='Title' {...field} />} />
                            <Controller name="description" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.description)} helperText={errors.description && errors.description.message} fullWidth label='Description' {...field} />} />
                            <Controller name="location" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.location)} helperText={errors.location && errors.location.message} fullWidth label='Location' {...field} />} />
                            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                                <Controller name="start" control={control} render={({ field }) => <DatePicker variant='standard' margin='dense' helperText={errors.start && errors.start.message} fullWidth label='Start Date' renderInput={(params) => <TextField {...params} error={isError(errors.start)} onChange={field.onChange} />} {...field} />} />
                                <Controller name="end" control={control} render={({ field }) => <DatePicker variant='standard' margin='dense' helperText={errors.end && errors.end.message} fullWidth label='End Date' renderInput={(params) => <TextField {...params} error={isError(errors.end)} onChange={field.onChange} />} {...field} />} />
                            </Stack>
                            <Controller name="emails" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.emails)} helperText={errors.emails && errors.emails.message} fullWidth label='Emails' {...field} />} />
                            <Button variant='contained' onClick={handleSubmit(onSubmit)} sx={{ alignSelf: 'flex-start' }}>Submit</Button>
                        </Stack>
                    </LocalizationProvider>
                </Box>
            </PageContent>
        </PageShell>
    )
}

